import { type MouseEvent } from "react";

/** Cancelling the mouse-down stops the button taking focus from the input; the click still fires. */
export const keepInputFocus = (event: MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
};
